import React from 'react'
import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import { Widget } from 'src/dashboard/components/Widgets/Widget'
import { Button } from 'src/design_system/components/Button/Button'
import { useSelector } from 'src/hooks'

const memberAvatarIds = Array.from({ length: 35 }, (_, index) => index + 1)

const COMMUNITY_URL =
  'https://community.promptings.com/communities/groups/promptings-community/home'

export const PromptingsCommunityWidget: React.FC = () => {
  const windowWidth = useSelector(state => state.window.width)
  const isMobile = windowWidth <= 516
  const isWide = windowWidth >= 1260

  return (
    <Widget
      alignment="start"
      paddingOverride="1rem"
      emptyState={{
        title: 'No community data',
        description: 'Promptings community info will appear here.',
        icon: 'share',
        action: {
          title: 'Close',
          onClick: () => {},
        },
      }}
      isEmpty={false}
      height={isWide ? '786px' : undefined}
      borderRadiusOverride="32px"
      shouldHideShadow={false}
    >
      <Flex flexDirection="column" width="100%" height="100%">
        <Flex
          borderRadius="20px"
          overflow="hidden"
          minHeight="260px"
          width="inherit"
          backgroundColor="#F5F5F8"
        >
          <div
            style={{
              width: '100%',
              minHeight: 260,
              height: 'auto',
              backgroundImage:
                'url(https://soc-website-public.s3.us-west-2.amazonaws.com/static/soc-website/images/manual/PromptingsCommunityDesktopGraphic.2.0.svg)',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              borderRadius: '20px',
              cursor: 'pointer',
            }}
            onClick={() => window.open(COMMUNITY_URL, '_blank', 'noreferrer')}
          />
        </Flex>
        <Flex
          flexDirection="column"
          inset={{ horizontal: 'x2', vertical: 'x2' }}
          rowGap="x1_5"
          style={{ flex: 1, minHeight: 0 }}
        >
          <Flex flexDirection="column" rowGap="x1_5">
            <Text
              type="subtitle"
              weight="semiBold"
              content="Promptings Community"
            />
            <Text type="footnote" color="primaryBody" content="Private Group" />
            <Text
              type="body"
              color="primaryBody"
              content="A community inspiring gratitude, connection, and acting on promptings. Share stories, and everyday acts that transform lives."
            />
            <Flex flexDirection="column" rowGap="x_5">
              <Text
                type="body"
                color="primaryHeading"
                weight="semiBold"
                content="Promptings Website"
              />
              <Text
                type="body"
                color="primaryBody"
                content="SendOutCards Website"
              />
            </Flex>
          </Flex>
          <Flex
            flexDirection="column"
            rowGap="x1"
            style={{ marginTop: 'auto' }}
          >
            <Button
              title="Join Community"
              onClick={() => window.open(COMMUNITY_URL, '_blank', 'noreferrer')}
              background="#424448"
              textColor="#fff"
              textSize="14px"
              height="44px"
              width="100%"
              borderRadius="10px"
            />
            <div
              style={{
                borderTop: '1px solid #e5e7eb',
                width: '100%',
                marginTop: '8px',
              }}
            />
            <Flex
              columnGap="x_25"
              style={{
                flexWrap: 'nowrap',
                overflowX: 'hidden',
                overflowY: 'hidden',
                position: 'relative',
                width: '100%',
              }}
            >
              {memberAvatarIds.map(id => (
                <Flex
                  key={id}
                  width="28px"
                  height="28px"
                  borderRadius="circle"
                  style={{
                    backgroundImage: `url(https://i.pravatar.cc/48?img=${id})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    flexShrink: 0,
                  }}
                />
              ))}
              {isMobile && (
                <Flex
                  alignItems="center"
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    height: '100%',
                    paddingLeft: '6px',
                    background:
                      'linear-gradient(90deg, rgba(255, 255, 255, 0), #fff 60%)',
                    pointerEvents: 'none',
                  }}
                >
                  <Text type="footnote" weight="semiBold" content="..." />
                </Flex>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Widget>
  )
}

export default PromptingsCommunityWidget
